import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import { Provider } from "react-redux";
import { ChakraProvider } from "@chakra-ui/react";
import ScrollToTop from "./ScrollToTop";
import FormContextProvider from "./pages/project-showcase/admin/Presentation/FormStateContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop>
        <ChakraProvider>
          <FormContextProvider>
            <App />
          </FormContextProvider>
        </ChakraProvider>
      </ScrollToTop>
    </BrowserRouter>
  </Provider>,
);
